const initstate = {
  leftCategory: {},
  contentData: {
    apiBreadcrumb: [],
    categorySettingAds: {
      promotion_01: { layoutData: { banner: [] } },
    },
    levelNoList: [],
  },
  promotionalMixProducts: {
    groupData: {},
    groupIds: [],
    groupLoadings: {},
  },
  /*
      統一資料來源，不再另維護「已選商品」state 避免資料不同步
      已加入選擇的商品 key 值為 levelNo + groupId 用來區分商品是屬於哪個分組促銷的, ex:
      {
      level_one: {
        group_one: { sku_one: 2 },
        group_two: { sku_two: 1 }
      },
      level_two: {
        group_oneone: { sku_oneone: 1 }
      }
      }
  */
  selectedProducts: {},
  pendingProductsToCart: {},
  showCartAlert: false,
  showCartAdded: false,
  addedProductAmount: 0,
  isCartAdding: false,
  // mobile only
  showProductsInCartForMobile: false,
  isProductsInCartValidWithPromotionForMobile: false,
};

export function promotionalMixState(state = initstate, action) {
  switch (action.type) {
    case "GET_PROMOTION_MIX_DATA": {
      return { ...state, ...action.payload };
    }

    case "GET_PROMOTION_MIX_PRODUCTS_DATA": {
      return {
        ...state,
        promotionalMixProducts: {
          ...state.promotionalMixProducts,
          ...action.payload,
        },
      };
    }

    case "CHANGE_GROUP_EFFECT_LOADING": {
      const { promotionalMixProducts } = state;
      const { groupKey, value } = action.payload;
      return {
        ...state,
        promotionalMixProducts: {
          ...promotionalMixProducts,
          groupLoadings: {
            ...promotionalMixProducts.groupLoadings,
            [groupKey]: value,
          },
        },
      };
    }

    case "GET_PROMOTION_MIX_PAGINATION_PRODUCT_DATA": {
      const { promotionalMixProducts } = state;
      const { groupKey, data } = action.payload;
      return {
        ...state,
        promotionalMixProducts: {
          ...promotionalMixProducts,
          groupData: {
            ...promotionalMixProducts.groupData,
            [groupKey]: data,
          },
        },
      };
    }

    case "APPEND_PROMOTION_MIX_PAGINATION_PRODUCT_DATA": {
      const { promotionalMixProducts } = state;
      const { groupKey, data } = action.payload;

      return {
        ...state,
        promotionalMixProducts: {
          ...promotionalMixProducts,
          groupData: {
            ...promotionalMixProducts.groupData,
            [groupKey]: {
              ...promotionalMixProducts.groupData[groupKey],
              skuData: [
                ...promotionalMixProducts.groupData[groupKey].skuData,
                ...data.skuData,
              ],
              pagination: data.pagination,
            },
          },
        },
      };
    }

    case "SET_SELECTED_PROMOTION_MIX_PRODUCTS": {
      return { ...state, selectedProducts: action.payload };
    }

    case "CLOSE_CART_ALERT_MODAL": {
      return { ...state, showCartAlert: false };
    }

    case "IS_PRODUCTS_IN_CART_VALID_WITH_PROMOTION_FOR_MOBILE": {
      return {
        ...state,
        isProductsInCartValidWithPromotionForMobile: action.payload,
      };
    }

    case "SHOW_PRODUCTS_IN_CART": {
      return { ...state, showProductsInCartForMobile: action.payload };
    }

    case "SET_IS_CART_ADDING": {
      return { ...state, isCartAdding: action.payload };
    }

    case "SET_SHOW_CART_ADDED": {
      const { isShow, productAmount } = action.payload;
      return {
        ...state,
        showCartAdded: isShow,
        addedProductAmount: productAmount,
      };
    }

    case "SET_PROMOTIONAL_MIX_CART_ALERT_MODAL": {
      return {
        ...state,
        showCartAlert: true,
        pendingProductsToCart: action.payload,
      };
    }

    default:
      return state;
  }
}

export default promotionalMixState;
